import lazyRoute from "@/router/lazy-route";

const PatientFlagList = lazyRoute(
  () => import("@/pages/app/provider/patient/flags/PatientFlagList")
);

export { PatientFlagList };
